module.exports = __webpack_public_path__ + "static/media/Accademia - White - 3884_386_2246.f352c108.jpg";